import type { Step } from 'react-joyride';

export const policyVersionsTourSteps: Step[] = [
    {
        target: 'body',
        content:
            'ໜ້າປະຫວັດສະບັບ: ເບິ່ງສະບັບການປ່ຽນແປງຂອງນະໂຍບາຍ ແລະ ເປີດເນື້ອໃນແຕ່ລະສະບັບ.',
        placement: 'center',
        disableBeacon: true,
    },
    {
        target: '[data-tourid="policy-versions-back"]',
        content: 'ສ່ວນຫົວໜ້າ: ປຸ່ມກັບຄືນ ແລະ ປຸ່ມເລີ່ມທົດສອບ.',
        placement: 'bottom',
    },
    {
        target: '[data-tourid="policy-versions-table"]',
        content: 'ຕາຕະລາງສະບັບນະໂຍບາຍ ແລະ ປຸ່ມເບິ່ງເນື້ອໃນສະບັບ.',
        placement: 'top',
    },
];
